var _path, _path2, _path3, _path4, _g, _g2, _circle, _circle2, _circle3, _rect, _rect2, _rect3, _rect4, _rect5, _g3, _g4, _path5, _path6, _circle4, _circle5, _circle6, _g5, _rect6, _g6, _rect7, _path7, _rect8, _rect9, _path8, _path9, _rect10, _rect11, _path10, _path11, _rect12, _rect13, _path12, _path13, _path14, _path15, _g7, _rect14, _path16, _g8, _rect15, _path17, _g9, _rect16, _path18, _g10, _rect17, _path19, _g11, _g12, _path20, _g13, _path21, _g14, _g15, _path22, _rect18, _path23, _rect19, _rect20, _g16, _rect21, _ellipse, _path24, _g17, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHeaderImage = function SvgHeaderImage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 695,
    height: 146,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#headerImage_svg__a)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3E4678",
    d: "M0 0h694.461v145.506H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M141.331-209.992 314.768-62.889-43.995 241.403-217.433 94.299zM628.711-80.194l84.829 71.95-218.365 185.208-84.828-71.949z",
    opacity: 0.05
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M483.005-283.914 735.046-70.141 208.224 376.69l-252.04-213.773z",
    opacity: 0.05
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M417.692-249.675 669.733-35.902 142.911 410.93l-252.04-213.773z",
    opacity: 0.05
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#headerImage_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F5F4F6",
    d: "M109.956 22.24a8.185 8.185 0 0 1 8.185-8.185h457.352a8.184 8.184 0 0 1 8.185 8.184v284.647a7.275 7.275 0 0 1-7.275 7.275H117.232a7.276 7.276 0 0 1-7.276-7.275z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#headerImage_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M583.678 45.47h-40.51a3.307 3.307 0 0 0-3.307 3.308V316.64h38.36a5.457 5.457 0 0 0 5.457-5.456z"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 548.955,
    cy: 56.06,
    r: 4.134,
    fill: "#CFD2E3"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 562.183,
    cy: 56.06,
    r: 4.134,
    fill: "#CFD2E3"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 575.411,
    cy: 56.06,
    r: 4.134,
    fill: "#CFD2E3"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 33.07,
    height: 12.401,
    x: 544.821,
    y: 75.057,
    fill: "#CFD2E3",
    rx: 1.819
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 32.16,
    height: 11.492,
    x: 545.276,
    y: 92.046,
    fill: "#107EFF",
    stroke: "#107EFF",
    strokeWidth: 0.909,
    rx: 1.364
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 33.07,
    height: 12.401,
    x: 544.821,
    y: 107.3,
    fill: "#CFD2E3",
    rx: 1.819
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 33.07,
    height: 12.401,
    x: 544.821,
    y: 123.834,
    fill: "#CFD2E3",
    rx: 1.819
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 33.07,
    height: 13.228,
    x: 544.821,
    y: 139.542,
    fill: "#CFD2E3",
    rx: 1.819
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#headerImage_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M136.329 40.676h80.938V313.5h-80.938z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#headerImage_svg__e)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 67.379,
    height: 19.18,
    x: 143.109,
    y: 45.884,
    fill: "#fff",
    stroke: "#474F85",
    strokeWidth: 0.827,
    rx: 3.224
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#474F85",
    strokeLinejoin: "round",
    strokeWidth: 0.827,
    d: "M149.97 50.431h7.275c.776 0 1.406.63 1.407 1.405v7.276c0 .776-.63 1.406-1.407 1.406h-7.275c-.776 0-1.405-.63-1.405-1.406v-7.276c0-.775.629-1.405 1.405-1.405Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#474F85",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.827,
    d: "m155.947 53.916-3.228 3.117-1.449-1.4"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 30.011,
    height: 3.638,
    x: 163.612,
    y: 53.655,
    fill: "#474F85",
    rx: 1.819
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#474F85",
    d: "M109.956 40.51h26.456v273.651h-19.18a7.276 7.276 0 0 1-7.276-7.275z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#626AA2",
    d: "M110.866 45.554h25.464v22.735h-25.464z"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 123.756,
    cy: 86.635,
    r: 5.615,
    fill: "#7E86BB"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 123.756,
    cy: 116.581,
    r: 5.615,
    fill: "#7E86BB"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 123.756,
    cy: 145.279,
    r: 5.615,
    fill: "#7E86BB"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#headerImage_svg__f)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M577.064 14.055a6.614 6.614 0 0 1 6.614 6.614V40.51H109.956V20.67a6.614 6.614 0 0 1 6.614-6.614z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("mask", {
    id: "headerImage_svg__g",
    width: 14,
    height: 13,
    x: 117,
    y: 21,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 12.625,
    height: 12.423,
    x: 117.434,
    y: 21.484,
    fill: "#F7F7F7",
    rx: 6.211
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#headerImage_svg__g)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E9EAF3",
    d: "M117.434 21.484h12.625v12.423h-12.625z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C5D4F0",
    d: "M112.619 38.068a1.73 1.73 0 0 1-.276-2.767l7.078-6.42a1.714 1.714 0 0 1 2.454.151l1.675 1.948a1.73 1.73 0 0 1-.194 2.449l-6.716 5.683a1.71 1.71 0 0 1-1.984.166z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8099CC",
    d: "M117.957 37.267a1.73 1.73 0 0 1 0-2.434l8.574-8.665a1.715 1.715 0 0 1 2.44 0l8.574 8.665c.666.673.666 1.76 0 2.434l-8.574 8.665c-.673.68-1.768.68-2.44 0z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 121.124,
    cy: 25.185,
    fill: "#8099CC",
    rx: 1.031,
    ry: 1.035
  })))), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 149.334,
    height: 4.96,
    x: 143.142,
    y: 24.802,
    fill: "#CFD2E3",
    rx: 2.397
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 0.827,
    d: "M116.571 14.468h460.493a6.2 6.2 0 0 1 6.201 6.2v286.879a6.2 6.2 0 0 1-6.201 6.201H116.571a6.2 6.2 0 0 1-6.202-6.201V20.669a6.2 6.2 0 0 1 6.202-6.201Z"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 68.206,
    height: 20.007,
    x: 142.695,
    y: 122.11,
    fill: "#F2F4F8",
    rx: 3.638
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 32.739,
    height: 3.638,
    x: 163.612,
    y: 130.294,
    fill: "#CFD2E3",
    rx: 1.819
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    stroke: "#2E2F3C",
    strokeLinejoin: "round",
    strokeWidth: 0.909,
    d: "M149.061 130.229h3.183v6.885h-3.183a.454.454 0 0 1-.454-.454v-5.976c0-.251.203-.454.454-.455ZM158.155 133.348h-2.273v3.767h2.273a.455.455 0 0 0 .454-.455v-2.858a.454.454 0 0 0-.454-.454Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    stroke: "#2E2F3C",
    strokeLinejoin: "round",
    strokeWidth: 0.909,
    d: "M155.427 127.112h-2.728a.455.455 0 0 0-.455.454v9.549h3.637v-9.549a.454.454 0 0 0-.454-.454Z"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 68.206,
    height: 20.007,
    x: 142.695,
    y: 96.646,
    fill: "#F2F4F8",
    rx: 3.638
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 23.645,
    height: 3.638,
    x: 163.612,
    y: 104.831,
    fill: "#CFD2E3",
    rx: 1.819
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    stroke: "#2E2F3C",
    strokeLinejoin: "round",
    strokeWidth: 0.827,
    d: "M149.97 101.606h7.275c.776 0 1.406.629 1.407 1.405v7.276c0 .776-.63 1.406-1.407 1.406h-7.275c-.776 0-1.405-.63-1.405-1.406v-7.276c0-.776.629-1.405 1.405-1.405Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    stroke: "#2E2F3C",
    strokeLinecap: "round",
    strokeWidth: 0.827,
    d: "M148.931 104.831h9.354M151.789 102.103v9.094M155.427 102.103v9.094M148.931 108.468h9.354"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 68.206,
    height: 20.007,
    x: 143.026,
    y: 71.1,
    fill: "#F2F4F8",
    rx: 3.638
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    width: 39.105,
    height: 3.638,
    x: 163.942,
    y: 79.284,
    fill: "#CFD2E3",
    rx: 1.819
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    stroke: "#2E2F3C",
    strokeLinejoin: "round",
    strokeWidth: 0.827,
    d: "M150.301 76.06h7.275c.776 0 1.406.63 1.406 1.405v7.276c0 .776-.63 1.406-1.406 1.406h-7.275c-.776 0-1.406-.63-1.406-1.406v-7.276a1.407 1.407 0 0 1 1.406-1.405Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    stroke: "#2E2F3C",
    strokeLinecap: "round",
    strokeWidth: 0.827,
    d: "M151.211 79.285h3.637M151.211 81.104h5.456M151.211 82.922h2.728"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    stroke: "#6EF3D6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.909,
    d: "m124.838 53.26-5.883 5.883 2.223 2.224 5.884-5.884z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    stroke: "#6EF3D6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.909,
    d: "m124.835 53.262 1.113-1.113a.79.79 0 0 1 1.113 0l1.113 1.113a.79.79 0 0 1 0 1.113l-1.113 1.113-2.221-2.222zM118.141 62.181l3.037-.815-2.222-2.221z"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#headerImage_svg__h)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M247.195 48.778a3.307 3.307 0 0 1 3.307-3.307h256.289a3.307 3.307 0 0 1 3.307 3.307v66.139a3.307 3.307 0 0 1-3.307 3.307H250.502a3.31 3.31 0 0 1-3.307-3.307z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("mask", {
    id: "headerImage_svg__i",
    width: 61,
    height: 44,
    x: 253,
    y: 68,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    width: 43.358,
    height: 59.255,
    x: 313.064,
    y: 68.619,
    fill: "#FBFBFD",
    rx: 2.462,
    transform: "rotate(90 313.064 68.62)"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#headerImage_svg__i)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "headerImage_svg__j",
    width: 61,
    height: 45,
    x: 253,
    y: 68,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#F7F7F7",
    d: "M253.324 68.171h59.587l.408 43.874h-59.587z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#headerImage_svg__j)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#headerImage_svg__k)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#headerImage_svg__l)",
    fillOpacity: 0.9,
    d: "M0 0h60.946v45.413H0z",
    transform: "matrix(1 0 .0093 .99996 252.914 67.724)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#headerImage_svg__m)",
    d: "M231.569 129.932c-1.315-.765-1.513-2.548-.395-3.545l37.519-33.437c.933-.832 2.391-.742 3.231.2l13.763 15.421a2.177 2.177 0 0 1-.222 3.141l-33.89 28.129a2.295 2.295 0 0 1-2.615.205z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#headerImage_svg__n)",
    d: "M261.624 123.303a2.18 2.18 0 0 1-.029-3.121l34.801-34.584c.877-.87 2.318-.87 3.211 0l35.462 34.602c.885.863.898 2.257.029 3.12l-34.801 34.584c-.877.871-2.318.871-3.211 0z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.081,
    cy: 3.015,
    fill: "url(#headerImage_svg__o)",
    fillOpacity: 0.9,
    rx: 3.081,
    ry: 3.015,
    transform: "matrix(1 0 .0093 .99996 262.762 75.782)"
  }))))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("mask", {
    id: "headerImage_svg__p",
    width: 60,
    height: 44,
    x: 317,
    y: 68,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    width: 43.358,
    height: 59.255,
    x: 376.723,
    y: 68.619,
    fill: "#FBFBFD",
    rx: 2.462,
    transform: "rotate(90 376.723 68.62)"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#headerImage_svg__p)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "headerImage_svg__q",
    width: 61,
    height: 45,
    x: 316,
    y: 68,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#F7F7F7",
    d: "M316.983 68.171h59.587l.408 43.874h-59.587z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#headerImage_svg__q)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#headerImage_svg__r)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#headerImage_svg__s)",
    fillOpacity: 0.9,
    d: "M0 0h60.946v45.413H0z",
    transform: "matrix(1 0 .0093 .99996 316.573 67.724)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#headerImage_svg__t)",
    d: "M295.228 129.932c-1.315-.765-1.514-2.548-.395-3.545l37.519-33.437c.933-.832 2.391-.742 3.231.2l13.763 15.421a2.177 2.177 0 0 1-.222 3.141l-33.89 28.129a2.295 2.295 0 0 1-2.615.205z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#headerImage_svg__u)",
    d: "M325.283 123.303a2.18 2.18 0 0 1-.029-3.121l34.801-34.584c.877-.87 2.318-.87 3.211 0l35.462 34.602a2.18 2.18 0 0 1 .03 3.12l-34.802 34.584c-.877.871-2.318.871-3.211 0z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.081,
    cy: 3.015,
    fill: "url(#headerImage_svg__v)",
    fillOpacity: 0.9,
    rx: 3.081,
    ry: 3.015,
    transform: "matrix(1 0 .0093 .99996 326.422 75.782)"
  }))))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("mask", {
    id: "headerImage_svg__w",
    width: 60,
    height: 44,
    x: 380,
    y: 68,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    width: 43.358,
    height: 59.255,
    x: 439.555,
    y: 68.619,
    fill: "#FBFBFD",
    rx: 2.462,
    transform: "rotate(90 439.555 68.62)"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#headerImage_svg__w)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "headerImage_svg__x",
    width: 61,
    height: 45,
    x: 379,
    y: 68,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#F7F7F7",
    d: "M379.815 68.171h59.587l.408 43.874h-59.587z"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#headerImage_svg__x)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#headerImage_svg__y)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#headerImage_svg__z)",
    fillOpacity: 0.9,
    d: "M0 0h60.946v45.413H0z",
    transform: "matrix(1 0 .0093 .99996 379.405 67.724)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#headerImage_svg__A)",
    d: "M358.06 129.932c-1.315-.765-1.514-2.548-.395-3.545l37.519-33.437c.933-.832 2.391-.742 3.231.2l13.763 15.421a2.177 2.177 0 0 1-.222 3.141l-33.89 28.129a2.295 2.295 0 0 1-2.615.205z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#headerImage_svg__B)",
    d: "M388.115 123.303a2.18 2.18 0 0 1-.029-3.121l34.801-34.584c.877-.87 2.318-.87 3.211 0L461.56 120.2c.885.863.898 2.257.029 3.12l-34.801 34.584c-.877.871-2.318.871-3.211 0z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.081,
    cy: 3.015,
    fill: "url(#headerImage_svg__C)",
    fillOpacity: 0.9,
    rx: 3.081,
    ry: 3.015,
    transform: "matrix(1 0 .0093 .99996 389.254 75.782)"
  }))))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("mask", {
    id: "headerImage_svg__D",
    width: 61,
    height: 44,
    x: 443,
    y: 68,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    width: 43.358,
    height: 59.255,
    x: 503.214,
    y: 68.619,
    fill: "#FBFBFD",
    rx: 2.462,
    transform: "rotate(90 503.214 68.62)"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#headerImage_svg__D)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "headerImage_svg__E",
    width: 61,
    height: 45,
    x: 443,
    y: 68,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#F7F7F7",
    d: "M443.474 68.171h59.587l.408 43.874h-59.587z"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#headerImage_svg__E)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#headerImage_svg__F)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#headerImage_svg__G)",
    fillOpacity: 0.9,
    d: "M0 0h60.946v45.413H0z",
    transform: "matrix(1 0 .0093 .99996 443.063 67.724)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#headerImage_svg__H)",
    d: "M421.719 129.932c-1.315-.765-1.514-2.548-.395-3.545l37.519-33.437c.933-.832 2.391-.742 3.231.2l13.763 15.421a2.177 2.177 0 0 1-.222 3.141l-33.89 28.129a2.295 2.295 0 0 1-2.615.205z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#headerImage_svg__I)",
    d: "M451.773 123.303a2.18 2.18 0 0 1-.029-3.121l34.802-34.584c.877-.87 2.318-.87 3.211 0l35.462 34.602c.885.863.898 2.257.029 3.12l-34.802 34.584c-.876.871-2.317.871-3.21 0z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.081,
    cy: 3.015,
    fill: "url(#headerImage_svg__J)",
    fillOpacity: 0.9,
    rx: 3.081,
    ry: 3.015,
    transform: "matrix(1 0 .0093 .99996 452.913 75.782)"
  }))))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#headerImage_svg__K)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 283.572,
    cy: 101.689,
    r: 8.267,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 283.572,
    cy: 101.689,
    r: 7.879,
    stroke: "#2E2F3C",
    strokeLinejoin: "round",
    strokeWidth: 0.776
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#2E2F3C",
    stroke: "#2E2F3C",
    strokeWidth: 0.388,
    d: "M286.397 99.502q.117.03.199.118l.048.062c.041.065.063.14.066.216l-.004.078a.44.44 0 0 1-.089.21l-.005.005-.005.005-4.056 4.371-.143.153-.141-.153-2.23-2.398-.01-.012a.43.43 0 0 1-.092-.286l.008-.076a.43.43 0 0 1 .106-.202l.057-.053a.4.4 0 0 1 .219-.077l.079.005a.4.4 0 0 1 .146.054l.062.047.011.011 1.78 1.918 3.618-3.89.005-.005.006-.005a.4.4 0 0 1 .287-.107z"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#headerImage_svg__L)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 410.063,
    cy: 101.689,
    r: 8.267,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 410.063,
    cy: 101.689,
    r: 7.879,
    stroke: "#2E2F3C",
    strokeLinejoin: "round",
    strokeWidth: 0.776
  }))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#2E2F3C",
    stroke: "#2E2F3C",
    strokeWidth: 0.388,
    d: "M412.889 99.502q.115.03.198.118l.048.062c.041.065.063.14.066.216l-.004.078a.43.43 0 0 1-.089.21l-.004.005-.005.005-4.057 4.371-.143.153-.141-.153-2.23-2.398-.009-.012a.43.43 0 0 1-.093-.286l.009-.076a.43.43 0 0 1 .105-.202l.058-.053a.4.4 0 0 1 .218-.077l.08.005a.4.4 0 0 1 .145.054l.063.047.01.011 1.781 1.918 3.618-3.89.005-.005.005-.005a.4.4 0 0 1 .288-.107z"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#headerImage_svg__M)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 346.404,
    cy: 101.689,
    r: 8.267,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 346.404,
    cy: 101.689,
    r: 7.879,
    stroke: "#CCCFE4",
    strokeLinejoin: "round",
    strokeWidth: 0.776
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#headerImage_svg__N)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 473.722,
    cy: 101.689,
    r: 8.267,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 473.722,
    cy: 101.689,
    r: 7.879,
    stroke: "#CCCFE4",
    strokeLinejoin: "round",
    strokeWidth: 0.776
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    stroke: "#474F85",
    strokeWidth: 0.827,
    d: "M247.278 63.245h262.82"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    width: 6.66,
    height: 6.66,
    x: 265.723,
    y: 51.341,
    fill: "#fff",
    stroke: "#2E2F3C",
    strokeWidth: 0.827,
    rx: 0.496
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    stroke: "#2E2F3C",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.827,
    d: "m259.071 55.918-2.495-2.495-2.496 2.495"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    width: 36.554,
    height: 2.495,
    x: 276.54,
    y: 53.423,
    fill: "#2E2F3C",
    rx: 1.248
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    width: 262.076,
    height: 71.926,
    x: 247.608,
    y: 45.884,
    stroke: "#474F85",
    strokeWidth: 0.827,
    rx: 2.894
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#headerImage_svg__O)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 262.903,
    height: 37.286,
    x: 247.195,
    y: 123.185,
    fill: "#fff",
    rx: 3.307
  }))), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    width: 255.462,
    height: 29.763,
    x: 250.915,
    y: 126.905,
    stroke: "#CFD2E3",
    strokeDasharray: "2.48 0.83",
    strokeWidth: 0.827,
    rx: 2.894
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 378.272,
    cy: 138.516,
    fill: "#6EF3D6",
    rx: 6.239,
    ry: 6.237
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1.631,
    d: "M378.272 136.218v4.596M380.57 138.516h-4.597"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#headerImage_svg__P)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 108.508,
    height: 37.203,
    x: 163.913,
    y: 44.31,
    fill: "#fff",
    stroke: "#474F85",
    strokeDasharray: "3.31 0.83",
    strokeWidth: 0.827,
    rx: 6.559,
    transform: "rotate(12.407 163.913 44.31)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#474F85",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.585,
    d: "m171.505 59.5.805 1.205 2.851-1.733M170.267 65.127l.805 1.205 2.851-1.732M169.029 70.754l.804 1.206 2.852-1.733M178.29 60.84l10.13 2.23M177.052 66.468l10.129 2.229M175.814 72.096l10.13 2.228"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 57.044,
    height: 6.972,
    x: 195.822,
    y: 66.969,
    fill: "#474F85",
    rx: 3.486,
    transform: "rotate(12.407 195.822 66.969)"
  }))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M218.893 87.276c1.085-.402 3.225-.156 3.79 1.069.481 1.044.895 2.804.917 2.429.055-.834-.054-2.637.31-3.58.264-.687.784-1.333 1.55-1.561.644-.194 1.401-.262 2.07-.124.707.144 1.451.648 1.729 1.127.818 1.408.831 4.291.87 4.138.144-.615.158-2.777.639-3.58.319-.53 1.123-1.005 1.553-1.082.664-.117 1.482-.154 2.178-.018.563.11 1.324.777 1.53 1.1.495.778.773 2.974.856 3.747.037.319.168-.888.662-1.663.918-1.444 4.167-1.724 4.289 1.444.059 1.478.046 1.41.046 2.404 0 1.166-.027 1.871-.091 2.716-.067.902-.262 2.947-.544 3.937-.195.68-.839 2.21-1.476 3.127 0 0-2.427 2.825-2.691 4.095-.265 1.272-.177 1.281-.231 2.181-.052.901.274 2.086.274 2.086s-1.81.235-2.789.076c-.883-.14-1.977-1.898-2.26-2.436-.388-.741-1.218-.598-1.541-.052-.506.866-1.602 2.418-2.373 2.516-1.511.189-4.643.067-7.095.045 0 0 .418-2.285-.513-3.069-.689-.588-1.876-1.772-2.585-2.395l-1.88-2.082c-.64-.813-2.265-2.099-2.809-4.485-.482-2.115-.434-3.153.083-4 .525-.86 1.514-1.331 1.93-1.412.47-.095 1.564-.088 1.977.14.504.278.708.36 1.103.883.52.694.705 1.03.482.274-.172-.592-.728-1.345-.981-2.192-.247-.816-.906-2.131-.859-3.449.018-.499.233-1.742 1.88-2.354",
    clipRule: "evenodd"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    stroke: "#2E2F3C",
    strokeLinejoin: "round",
    strokeWidth: 1.695,
    d: "M218.893 87.276c1.085-.402 3.225-.156 3.79 1.069.481 1.044.895 2.804.917 2.429.055-.834-.054-2.637.31-3.58.264-.687.784-1.333 1.55-1.561.644-.194 1.401-.262 2.07-.124.707.144 1.451.648 1.729 1.127.818 1.408.831 4.291.87 4.138.144-.615.158-2.777.639-3.58.319-.53 1.123-1.005 1.553-1.082.664-.117 1.482-.154 2.178-.018.563.11 1.324.777 1.53 1.1.495.778.773 2.974.856 3.747.037.319.168-.888.662-1.663.918-1.444 4.167-1.724 4.289 1.444.059 1.478.046 1.41.046 2.404 0 1.166-.027 1.871-.091 2.716-.067.902-.262 2.947-.544 3.937-.195.68-.839 2.21-1.476 3.127 0 0-2.427 2.825-2.691 4.095-.265 1.272-.177 1.281-.231 2.181-.052.901.274 2.086.274 2.086s-1.81.235-2.789.076c-.883-.14-1.977-1.898-2.26-2.436-.388-.741-1.218-.598-1.541-.052-.506.866-1.602 2.418-2.373 2.516-1.511.189-4.643.067-7.095.045 0 0 .418-2.285-.513-3.069-.689-.588-1.876-1.772-2.585-2.395l-1.88-2.082c-.64-.813-2.265-2.099-2.809-4.485-.482-2.115-.434-3.153.083-4 .525-.86 1.514-1.331 1.93-1.412.47-.095 1.564-.088 1.977.14.504.278.708.36 1.103.883.52.694.705 1.03.482.274-.172-.592-.728-1.345-.981-2.192-.247-.816-.906-2.131-.859-3.449.018-.499.233-1.742 1.88-2.354Z",
    clipRule: "evenodd"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    stroke: "#2E2F3C",
    strokeLinecap: "round",
    strokeWidth: 1.695,
    d: "M234.696 104.672v-7.816M230.141 104.699l-.036-7.848M225.631 96.922l.047 7.742"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    stroke: "#8C92B6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.827,
    d: "m77.764 21.712-.877-1.87-.877 1.87-1.604 1.023 1.604 1.023.877 1.871.877-1.87 1.603-1.024z",
    clipRule: "evenodd"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#6EF3D6",
    fillRule: "evenodd",
    d: "m64.093 105.163 2.046-3.474 2.046 3.474 3.741 1.9-3.74 1.9-2.047 3.474-2.046-3.474-3.741-1.9z",
    clipRule: "evenodd",
    opacity: 0.7
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#2ACDFF",
    fillOpacity: 0.7,
    fillRule: "evenodd",
    d: "m602.351 124.495 1.169-2.138 1.169 2.138 2.138 1.169-2.138 1.17-1.169 2.137-1.169-2.137-2.138-1.17z",
    clipRule: "evenodd"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    stroke: "#8C92B6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.827,
    d: "m660.373 97.747-1.462-2.672-1.461 2.672-2.672 1.462 2.672 1.461 1.461 2.673 1.462-2.673 2.672-1.461z",
    clipRule: "evenodd"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#2ACDFF",
    fillRule: "evenodd",
    d: "m30.781 56.41 1.462-2.672 1.461 2.672 2.672 1.462-2.672 1.461-1.461 2.673-1.462-2.673-2.672-1.461z",
    clipRule: "evenodd"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    stroke: "#6EF3D6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.827,
    d: "m624.288 46.197-1.753-3.207-1.754 3.207-3.207 1.754 3.207 1.753 1.754 3.207 1.753-3.207 3.207-1.753z",
    clipRule: "evenodd"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    stroke: "#CFD2E3",
    strokeWidth: 0.827,
    d: "M539.861 63.245h43.817"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "headerImage_svg__l",
    x1: 25.046,
    x2: 31.683,
    y1: 14.759,
    y2: 81.362,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5D4F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5D4F0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "headerImage_svg__m",
    x1: 265.415,
    x2: 268.297,
    y1: 125.478,
    y2: 87.167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9AADE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8099CC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "headerImage_svg__n",
    x1: 312.984,
    x2: 359.879,
    y1: 158.415,
    y2: 138.579,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.16
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "headerImage_svg__o",
    x1: 2.533,
    x2: 3.681,
    y1: 1.96,
    y2: 10.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5D4F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5D4F0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "headerImage_svg__s",
    x1: 25.046,
    x2: 31.683,
    y1: 14.759,
    y2: 81.362,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5D4F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5D4F0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "headerImage_svg__t",
    x1: 329.074,
    x2: 331.956,
    y1: 125.478,
    y2: 87.167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9AADE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8099CC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "headerImage_svg__u",
    x1: 376.643,
    x2: 423.538,
    y1: 158.415,
    y2: 138.579,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.16
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "headerImage_svg__v",
    x1: 2.533,
    x2: 3.681,
    y1: 1.96,
    y2: 10.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5D4F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5D4F0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "headerImage_svg__z",
    x1: 25.046,
    x2: 31.683,
    y1: 14.759,
    y2: 81.362,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5D4F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5D4F0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "headerImage_svg__A",
    x1: 391.906,
    x2: 394.788,
    y1: 125.478,
    y2: 87.167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9AADE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8099CC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "headerImage_svg__B",
    x1: 439.475,
    x2: 486.37,
    y1: 158.415,
    y2: 138.579,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.16
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "headerImage_svg__C",
    x1: 2.533,
    x2: 3.681,
    y1: 1.96,
    y2: 10.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5D4F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5D4F0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "headerImage_svg__G",
    x1: 25.046,
    x2: 31.683,
    y1: 14.759,
    y2: 81.362,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5D4F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5D4F0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "headerImage_svg__H",
    x1: 455.565,
    x2: 458.447,
    y1: 125.478,
    y2: 87.167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9AADE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8099CC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "headerImage_svg__I",
    x1: 503.134,
    x2: 550.029,
    y1: 158.415,
    y2: 138.579,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.16
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "headerImage_svg__J",
    x1: 2.533,
    x2: 3.681,
    y1: 1.96,
    y2: 10.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5D4F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5D4F0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("filter", {
    id: "headerImage_svg__b",
    width: 528.286,
    height: 354.671,
    x: 82.674,
    y: -13.228,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 13.641
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_887_1863"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_887_1863",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "headerImage_svg__c",
    width: 73.828,
    height: 301.181,
    x: 524.856,
    y: 30.465,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.503
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.278431 0 0 0 0 0.360784 0 0 0 0 0.686275 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_887_1863"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_887_1863",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "headerImage_svg__d",
    width: 110.948,
    height: 302.835,
    x: 121.324,
    y: 25.671,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.503
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.278431 0 0 0 0 0.360784 0 0 0 0 0.686275 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_887_1863"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_887_1863",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "headerImage_svg__e",
    width: 82.757,
    height: 34.558,
    x: 135.42,
    y: 40.014,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.819
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.638
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_887_1863"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_887_1863",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "headerImage_svg__f",
    width: 510.098,
    height: 62.832,
    x: 91.768,
    y: 1.323,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.456
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9.094
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.411765 0 0 0 0 0.415686 0 0 0 0 0.435294 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_887_1863"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_887_1863",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "headerImage_svg__h",
    width: 290.185,
    height: 100.035,
    x: 233.554,
    y: 31.829,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.821
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.385218 0 0 0 0 0.363819 0 0 0 0 0.516667 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_887_1863"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_887_1863",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "headerImage_svg__k",
    width: 64.323,
    height: 48.366,
    x: 251.436,
    y: 66.246,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.739
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.278431 0 0 0 0 0.360784 0 0 0 0 0.686275 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_887_1863"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_887_1863",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "headerImage_svg__r",
    width: 64.323,
    height: 48.366,
    x: 315.095,
    y: 66.246,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.739
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.278431 0 0 0 0 0.360784 0 0 0 0 0.686275 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_887_1863"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_887_1863",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "headerImage_svg__y",
    width: 64.323,
    height: 48.366,
    x: 377.927,
    y: 66.246,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.739
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.278431 0 0 0 0 0.360784 0 0 0 0 0.686275 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_887_1863"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_887_1863",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "headerImage_svg__F",
    width: 64.323,
    height: 48.366,
    x: 441.586,
    y: 66.246,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.739
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.278431 0 0 0 0 0.360784 0 0 0 0 0.686275 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_887_1863"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_887_1863",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "headerImage_svg__K",
    width: 50.68,
    height: 50.68,
    x: 258.231,
    y: 76.349,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.536
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_887_1863"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_887_1863",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "headerImage_svg__L",
    width: 50.68,
    height: 50.68,
    x: 384.723,
    y: 76.349,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.536
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_887_1863"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_887_1863",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "headerImage_svg__M",
    width: 50.68,
    height: 50.68,
    x: 321.064,
    y: 76.349,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.536
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_887_1863"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_887_1863",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "headerImage_svg__N",
    width: 50.68,
    height: 50.68,
    x: 448.382,
    y: 76.349,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.536
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_887_1863"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_887_1863",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "headerImage_svg__O",
    width: 290.185,
    height: 64.569,
    x: 233.554,
    y: 109.543,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.821
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.384314 0 0 0 0 0.364706 0 0 0 0 0.517647 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_887_1863"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_887_1863",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "headerImage_svg__P",
    width: 140.173,
    height: 85.854,
    x: 142.816,
    y: 34.693,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.486
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.972
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_887_1863"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_887_1863",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "headerImage_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h694.461v145.506H0z"
  })))));
};
export default SvgHeaderImage;